import PropTypes from 'prop-types';
import cx from 'classnames';

import withTheme from 'core/hocs/withTheme';

import styles from './index.styl';

function GameCompareSkeleton({ theme }) {
  const {
    controls: {
      gameCompare: {
        compare: {
          margin,
          borderRadius,
        },
      },
    },
  } = theme;

  return (
    <div className={styles.content}>
      <style jsx>{`
        .${styles.content}
          margin ${margin || 0}
          border-radius ${borderRadius}px
      `}</style>
      <div className={cx('lb-skeleton', styles.cover)} />
      <div className={cx('lb-skeleton', styles.cover)} />
    </div>
  );
}

GameCompareSkeleton.propTypes = {
  theme: PropTypes.object,
};

export default withTheme(GameCompareSkeleton);
